// extracted by mini-css-extract-plugin
export default {"error-wrapper":"AutoCreate_error-wrapper__056uY","loader-wrapper":"AutoCreate_loader-wrapper__TDpmH"};